/* ==========================================================================

 Logout Handler

 Author:      Dave Taylor (http://davetayls.me)

 Description:

 We have been told to cater for logging the user out of sessions
 linked to external sites with legacy code which doesn't respond
 correctly to the SSO process.

 This usually entails a GET request to a logout endpoint of some
 sort. To be able to cater for non js users the server will place
 these urls inside <img> tags.

 This code checks the state of each img to make sure the call has
 completed. We are not verifying it's success as this is a
 temporary work-around.

 This page can be given a `?originalUrl=/` path to redirect the user
 back to a the page they were on when they clicked log out as long
 as it was inside arrow.com.

 ========================================================================== */
'use strict';

var $ = require('jquery');
var mediator = require('../mediator');
var config = require('../config');
var started = (new Date()).getTime();
var minimumViewTime = 2000;
var moment = require('moment-timezone');

// This will redirect the page to the url which has been requested by the server
// if there are no logout triggers left to complete
function hasTriggersLeft(triggersToComplete, originalUrl) {
  if (triggersToComplete === 0) {
    if (moment().valueOf(new Date()) - started > minimumViewTime) {
      mediator.trigger(config.events.requestPageReload, originalUrl || '/');
    } else {
      setTimeout(function() {
        mediator.trigger(config.events.requestPageReload, originalUrl || '/');
      }, minimumViewTime);
    }
    return false;
  }
  return true;
}

exports.create = function($parent) {
  $parent.find('.LogoutHandler').each(function() {
    var $this = $(this);
    var $title = $this.find('.LogoutHandler-title');
    var $message = $this.find('.LogoutHandler-message');

    // Keep track of how many img logout triggers are yet to complete
    var $triggers = $this.find('.LogoutHandler-trigger');
    var triggersToComplete = $triggers.length;

    // The server will tell us the url to redirect to
    var originalUrl = $this.data('originalUrl');

    // Change the non-js version of the messaging to
    // something that handles a non-ready state
    $title.text($title.data('title'));
    $message.text($message.data('message'));

    $this.addClass('LogoutHandler--loggingOut');

    if (hasTriggersLeft(triggersToComplete, originalUrl)) {
      $triggers.each(function(i, img) {
        if (img.complete) {
          triggersToComplete -= 1;
          hasTriggersLeft(triggersToComplete, originalUrl);
        } else {
          // Fix for IE not liking the response having text/plain
          // It will not img trigger load/error events
          $(img).remove();
          $.ajax({ url: img.src, handleErrorLocally: true}).then(function() {
            triggersToComplete -= 1;
            hasTriggersLeft(triggersToComplete, originalUrl);
          });
        }
      });
    }

  });
};



// WEBPACK FOOTER //
// ./assets/js/components/logoutHandler.js